import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useLazyGetPublicDataFileQuery } from "@/redux/service";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import { t } from "i18next";

const PublicFile = () => {
  const { uuid } = useParams();

  const [getPublicDataFile, publicFileResponse] =
    useLazyGetPublicDataFileQuery();

  useEffect(() => {
    if (uuid) {
      getPublicDataFile(uuid);
    }
  }, [uuid]);

  useEffect(() => {
    if (publicFileResponse.isSuccess) {
      window.location.href = publicFileResponse.data.link;
    }
  }, [publicFileResponse]);

  return (
    <div className="public-file-container">
      <BaseSpinner />

      {publicFileResponse.data?.link && (
        <span className="body-m-regular">
          <span>{t("labels.havingTroublePart1")}</span>
          <a
            href={publicFileResponse.data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("labels.here")}
          </a>
          <span>{t("labels.havingTroublePart2")}</span>
        </span>
      )}
    </div>
  );
};

export default PublicFile;
